module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/userIcon@3x-cbee0f5c25f7788e595396993ccb4746.png";